import { CSSProperties } from "react";

/**
 * 日時をフォーマットする
 * @param date 日時
 * @returns フォーマットされた日時
 */
export const formatTimestamp = (date: Date | string | number): string => {
  const dateObj = date instanceof Date ? date : new Date(date);
  return dateObj.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * 設定パラメータを取得する
 * @returns 設定パラメータ
 */
export function getChatbotConfig() {
  const rootElement = document.getElementById("chatbot-root");

  return {
    corporate_id: rootElement?.getAttribute("data-tenant-id") || "1",
    chatbot_id:
      rootElement?.getAttribute("data-chatbot-id") ||
      "11111111-1111-1111-1111-111111111111",
    config_key: rootElement?.getAttribute("data-config-key") || "x",
    corporate_uuid: rootElement?.getAttribute("data-tenant-uuid") || 
      "00000000-0000-0000-0000-000000000000",
  };
}

/**
 * チャットボットの位置を取得する
 * @returns チャットボットの位置
 */
export function getChatbotPosition() {
  const rootElement = document.getElementById("chatbot-root");

  return {
    position: rootElement?.getAttribute("chatbot-position") || "right",
    offset_x: rootElement?.getAttribute("chatbot-offset-x") || "1",
    offset_y: rootElement?.getAttribute("chatbot-offset-y") || "1",
  };
}

/**
 * 位置スタイル
 * @param leftOrRight - 左か右か
 * @param offset_x - 端からの距離
 * @param offset_y - 下からの距離
 * @param isMaximized - 最大化
 * @param alignment - DB設定の左か右か
 * @param db_offset_x - DB設定の余白
 * @param db_offset_y - DB設定の余白
 * @returns 位置スタイル
 */
export function getDockPositionStyles(
  leftOrRight: string,
  offset_x: number = 20,
  offset_y: number = 75,
  isMaximized: boolean = false,
  alignment: string,
  db_offset_x?: number,
  db_offset_y?: number
): CSSProperties {
  // DB設定を優先
  let horizontalMargin = db_offset_x ?? offset_x;
  let verticalMargin = db_offset_y ?? offset_y;
  const leftOrRightStyle = alignment ?? leftOrRight;

  const visualViewportHeight =
    (window as any).visualViewport?.height || window.innerHeight;
  const viewportHeightDiff = window.innerHeight - visualViewportHeight;

  let maximizedVerticalMargin = verticalMargin;
  if (isSmartPhone()) {
    horizontalMargin = 0;
    verticalMargin += viewportHeightDiff;
    maximizedVerticalMargin = verticalMargin;
  }

  return {
    position: "fixed",
    right:
      leftOrRightStyle === "right"
        ? isMaximized
          ? "0px"
          : `${horizontalMargin}px`
        : "auto",
    left:
      leftOrRightStyle === "left"
        ? isMaximized
          ? "0px"
          : `${horizontalMargin}px`
        : "auto",
    bottom: `${isMaximized ? maximizedVerticalMargin : verticalMargin}px`,
    top: "auto",
    zIndex: 199999,
  };
}

export function isSmartPhone(): boolean {
  const userAgent = navigator.userAgent.toLowerCase();
  console.log(userAgent);
  if (/android|iphone|blackberry|mobile/i.test(userAgent)) {
    return true;
  }
  return false;
}
